import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 'hoy',
      name: i18n.t('tipos.active_periods.today_plural'),
      nameSingular: i18n.t('tipos.active_periods.today'),
      timePeriod: i18n.t('tipos.recurrencia.diario')
    },
    {
      id: 'semana',
      name: i18n.t('tipos.active_periods.week_plural'),
      nameSingular: i18n.t('tipos.active_periods.week'),
      timePeriod: i18n.t('tipos.recurrencia.semanal')
    },    
    {
      id: 'mes',
      name: i18n.t('tipos.active_periods.month_plural'),
      nameSingular: i18n.t('tipos.active_periods.month'),
      timePeriod: i18n.t('tipos.recurrencia.mensual')
    },    
    {
      id: 'trimestre',
      name: i18n.t('tipos.active_periods.quarter_plural'),
      nameSingular: i18n.t('tipos.active_periods.quarter'),
      timePeriod: i18n.t('tipos.recurrencia.trimestral')
    },    
    {
      id: 'año',
      name: i18n.t('tipos.active_periods.year_plural'),
      nameSingular: i18n.t('tipos.active_periods.year'),
      timePeriod: i18n.t('tipos.recurrencia.anual')
    }
  ]
}

export function ACTIVE_PERIODS (state) {
  return configHelper.getConfig(state, 'ACTIVE_PERIODS', GenerateConfig)
}
